var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#4C6AFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 0.8,
    width: 6,
    height: 6,
    rx: 1,
    transform: "rotate(15 9.5 .8)",
    fill: "#97C0F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 8.5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#4C6AFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#4C6AFF"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS41MDAyNCIgeT0iMS40OTk5NyIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9IiM0QzZBRkYiLz4KPHJlY3QgeD0iOS41MDAyNCIgeT0iMC43OTk5ODgiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgxNSA5LjUwMDI0IDAuNzk5OTg4KSIgZmlsbD0iIzk3QzBGOCIvPgo8cmVjdCB4PSIxLjUwMDI0IiB5PSI4LjQ5OTk3IiB3aWR0aD0iNiIgaGVpZ2h0PSI2IiByeD0iMSIgZmlsbD0iIzRDNkFGRiIvPgo8cmVjdCB4PSI4LjUwMDI0IiB5PSI4LjQ5OTk3IiB3aWR0aD0iNiIgaGVpZ2h0PSI2IiByeD0iMSIgZmlsbD0iIzRDNkFGRiIvPgo8L3N2Zz4K";
export { SvgAll as ReactComponent };